import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { Accounting, UnitDto } from '../../../../context/GlobalContext'
import { useFormikContext } from 'formik'
import { InvoiceMutationDto } from '../../../../config/finance/invoiceConfig'
import FormikTextField from '../../../../components/Formik/TextField/FormikTextField'
import useUnits from '../../../../hooks/useUnits'
import { useTranslation } from 'react-i18next'
import FormikField from '../../../Formik/FormikField'
import UnitCombobox, { UnitComboboxProps } from '../../../Combobox/UnitCombobox'

export default function FinanceUnitField(): ReactElement {
    const { t: translate } = useTranslation()

    const context = useFormikContext<InvoiceMutationDto>()
    const { units } = useUnits()
    const unit = useMemo<UnitDto>(
        () => (units || []).find(data => data.key === context.values.unit),
        [context.values.unit, units],
    )

    return (
        <>
            <FormikField<UnitComboboxProps>
                context={context}
                label={translate('invoice.edit.form.other.unit')}
                fieldName={'unit'}
                component={UnitCombobox}
                componentProps={{
                    selectedOptions: [context.values.unit],
                    onOptionSelect: (_, data) => {
                        context.setFieldValue('unit', data.selectedOptions?.[0])
                    },
                }}
            />
            {[Accounting.Exact].includes(unit?.accounting) && (
                <FormikTextField
                    context={context}
                    label={translate('invoice.edit.form.other.period')}
                    fieldName="period"
                />
            )}
        </>
    )
}
